const mapData = (() => {
	const storeData = {};
	let id = 1;

	return {
		set(element, key, data) {
			if (typeof element.ltaKey === 'undefined') {
				element.ltaKey = {
					key,
					id
				};
				id++;
			}

			storeData[element.ltaKey.id] = data;
		},
		get(element, key) {
			if (!element || typeof element.ltaKey === 'undefined') {
				return null;
			}

			const keyProperties = element.ltaKey;
			if (keyProperties.key === key) {
				return storeData[keyProperties.id];
			}

			return null;
		},
		delete(element, key) {
			if (typeof element.ltaKey === 'undefined') {
				return;
			}

			const keyProperties = element.ltaKey;
			if (keyProperties.key === key) {
				delete storeData[keyProperties.id];
				delete element.ltaKey;
			}
		}
	};
})();

const Data = {
	setData(instance, key, data) {
		mapData.set(instance, key, data);
	},
	getData(instance, key) {
		return mapData.get(instance, key);
	},
	removeData(instance, key) {
		mapData.delete(instance, key);
	}
};

export default Data;
